import { Component, Input,  ElementRef, ViewChildren, QueryList, HostListener } from "@angular/core";
import { Subscription } from 'rxjs';
import { Helper } from "src/4services/2helper";
import ims from '../../imports';

@Component({
    selector: "c_dtable_mp_session_code_settings_component",
    templateUrl: "./c_dtable_mp_session_code_settings_component.html",
    styleUrls: ["../../common.scss", "../mp_session_code_settings.scss"],
    standalone: false
})
export class c_dtable_mp_session_code_settings_component {
  // ------------------------------------------------------------------------
  @ViewChildren('actionMenus', {read: ElementRef}) actionMenus: QueryList<any>

  isLoading: boolean = false;
  isHasViewPermission: boolean = false;
  isBasicPlan: boolean = false;

  tableHeader = [
    { name: 'Resolution Category', value: null, width: "35%" },
    { name: 'Response Type', value: null, width: "55%" },
    { name: '', value: null, width: "5%" },
  ]
  resolutionCodeList = []

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.resolutionCodeList.forEach(type=> {
          if (`type-${type.id}` === actionMenu.nativeElement.id) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              type.isShowMenu = false;
            }
          }
        })
      })
    }
  }

  constructor(
    private helper: Helper, 
  ){}
  private resolutionCodes$w: Subscription;
  watch() {
    this.resolutionCodes$w = this.helper.mp_sessions.resolutionCodes$w().subscribe(v => this.on_changed_value(v))
  }
  unwatch() {
    this.resolutionCodes$w?.unsubscribe();
  }

  async ngOnInit(){
    this.isLoading = false;
    await this.helper.permission.load_my_permissions_only_if_not_loaded();
    await this.getDealerPlan();
    
    this.watch();
    this.isHasViewPermission = this.helper.permission.has('dealer_mp_session_response_read')
    await this.getResolutionCodeList();
    this.isLoading = false;
  }
  ngOnDestroy(){
    this.unwatch();
  }

  async getDealerPlan(){
    try {
      await this.helper.dealer_plan.get_dealer_plan()
      this.isBasicPlan = this.helper.dealer_plan.isStandardPlan()
    } catch(err) {
      this.isLoading = false;
    }
  }
  async getResolutionCodeList(){
    try {
      if(!this.isHasViewPermission) return
      await this.helper.mp_sessions.load_mp_session_resolution_codes();
    } catch(err) {
      this.isLoading = false;
    }
  }

  on_changed_value(v){
    if(!this.isHasViewPermission) return
    if(!v || !v[0]) return;
    this.resolutionCodeList = v
  }
  // ------------------------------------------------------------------------
  determineElementToShow(){
    if(this.isLoading) return false
    if(!this.isHasViewPermission || this.isBasicPlan) return 'no-permission'
    if(!this.resolutionCodeList?.length) return 'no-data'
    return 'normal'
  } 
  
  toggleMenu(type){
    const targetMenu = type.isShowMenu;
    type.isShowMenu = !targetMenu;
  }

  setMorePosition(type) {
    const docElem = document.documentElement
    let elem = document?.getElementById('code-'+type?.id);
    let more = document?.getElementById('code-more-'+type?.id);
    let rect = elem?.getBoundingClientRect();
    const posX = docElem?.clientWidth - rect?.right + 5
    const posY = rect?.top - 22;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  goToDetail(type){
    this.helper.router.navigate_to(`/reports/sessions-type/${type.id}`);
  }
}
